import React from "react"

import PropTypes from "prop-types"

import * as styles from "./heading.module.scss"

const Heading = ({
  className,
  children,
  level,
  semantic,
  id,
  center,
  standalone,
  html,
}) => {
  const HeadingElement = semantic ? `h${level}` : "div"
  return (
    <HeadingElement
      id={id}
      className={`${styles[`h${level}`]} ${className} ${
        center ? styles.center : ""
      }  ${standalone ? styles.standalone : ""}`}
      dangerouslySetInnerHTML={html ? { __html: html } : null}
    >
      {html ? null : children}
    </HeadingElement>
  )
}

export default Heading

Heading.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  level: PropTypes.string,
  semantic: PropTypes.bool,
  id: PropTypes.string,
  center: PropTypes.bool,
  standalone: PropTypes.bool,
  html: PropTypes.string,
}

Heading.defaultProps = {
  className: "",
  level: "1",
  semantic: true,
  id: "",
  center: false,
  standalone: false,
  html: null,
}
